import React from 'react';
import PropTypes from 'prop-types';

const MoreItemsArrow = ({onClick, text}) => {
  return (
    <div className="text-center" onClick={onClick} style={{cursor: 'pointer'}}>
      {text && <div className="text-12">{text}</div>}
      <span className="gray-arrow arrow--bottom"/>
    </div>
  );
};

MoreItemsArrow.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string
};

export default MoreItemsArrow;
